import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../../../common/Spinner";
import api from "../../../../services/api";
import { useNotification } from "../../../../context/NotificationContext";
import { NotificationType, Position } from "../../../../types/enums/notificationEnums";
import { useTranslation } from "react-i18next";
import useRegisterPageLogic from "./registerPage.logic";

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const {showNotification} = useNotification();
  const { t } = useTranslation();
  const {resetCountdown} = useRegisterPageLogic();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const res = await api.post(`/auth/verify-email/${token}`);
  
        if (res.data.success) {
          showNotification(
            t('Your verification is completed successfully.'),
            NotificationType.Success,
            Position.TopRight
          );
          resetCountdown();
          navigate("/login");
        } else {
          showNotification(
            t('An error occurred during verification.'),
            NotificationType.Error,
            Position.TopRight
          );
        }
      } catch (error: any) {
        showNotification(
          error?.response?.data?.message || error.message || t('An error occurred during verification.'),
          NotificationType.Error,
          Position.TopRight
        );
        navigate("/login")
      }
    };
  
    if (token) {
      verifyEmail();
    } else {
      showNotification(
        t('An error occurred during verification.'),
        NotificationType.Error,
        Position.TopRight
      );
    }
  }, [token, navigate]);
  

  return (
    <div className="w-full h-screen text-stone-900 dark:text-zinc-100 flex items-center justify-center">
        <Spinner/>
    </div>
  );
};

export default VerifyEmailPage;
